import {ConversationType} from '@toolify/server/src/models/mongoose/MessageModel/enum/ConversationType'
import {IConversationTypeInterfacesMap} from '@toolify/server/src/services/MessageService/types/IConversationTypeInterfacesMap'
import {
  getDatabaseCellConversationKey,
} from '@toolify/client/src/modules/chat/functions/getDatabaseCellConversationKey'

type AnyConversationPayload = IConversationTypeInterfacesMap[ConversationType]['conversationTypePayload']
type DatabaseCellPayload = IConversationTypeInterfacesMap[ConversationType.DatabaseCell]['conversationTypePayload']

export function useDatabaseCellConversationTypeStrategy() {
  const getConversationKey = (payload: AnyConversationPayload): string => {
    const typed = payload as DatabaseCellPayload
    return `${typed.databaseItemId}-${typed.databasePropertyId}`
  }

  const getRelayConversationKey = (payload: AnyConversationPayload): string => {
    const typed = payload as DatabaseCellPayload
    return getDatabaseCellConversationKey(typed.databaseItemId, typed.databasePropertyId)
  }

  return {
    getConversationKey,
    getRelayConversationKey,
  }
}
